export const WORK_ORDER_LIST = "work_order_list";
export const WORK_ORDER_LIST_SUCCESSFULL = "Work_order_list_successfull";
export const CREATE_WORK_ORDER = 'create_work_order';
export const CREATE_WORK_ORDER_SUCCESSFULL = 'create_work_order_successfull';
export const UPDATE_PO_WO = "update_po_wo"
export const UPDATE_PO_WO_SUCCESSFULL = "update_po_wo_successfull"
export const API_ERRORS = 'api_failed';